/**
 * PageContentSRHandlers
 *
 * Factory for SignalR socket handlers used in PageContent.
 * Extracted from PageContent to keep that file focused on lifecycle and routing only.
 *
 * Each key matches a SignalR event name (p.A).
 * Adding a new BE event: add a handler here, PageContent needs no changes.
 */
import topicGroupEngine from './DashboardComponents/YourNotesTab/YourNotesGroupManager/TopicGroupEngine';
import groupNodeEngine from './DashboardComponents/YourNotesTab/Engines/GroupNodeEngine';
import templateEngine from './DashboardComponents/TemplateEngine/TemplateEngine';
import userEngine from '../controllers/User/UserEngine'; // ADDED
import calendarEngine from '../CalendarWidget/Core/CalendarEngine';
import yourDataEngine from './DashboardComponents/YourDataTab/YourDataEngine';
import searchEngine from './DashboardComponents/YourSearchTab/Core/SearchEngine';
import noteOptionsPanelEngine from './DashboardComponents/NoteOptionsPanel/Core/NoteOptionsPanelEngine';
import bodyEditorEngine from '../BodyEditorWidget/Core/BodyEditorEngine';
import floatingPanelEngine from './DashboardComponents/YourLibraryTab/Core/FloatingPanelEngine';
import formConfigEngine from '../Widgets/FormBuilderWidget/Core/FormConfigEngine';
import csCodeTemplateEngine from '../Widgets/CsCodeGenWidget/Core/CsCodeTemplateEngine';
import csCodeGenConfigEngine from '../Widgets/CsCodeGenWidget/Core/CsCodeGenConfigEngine';
import umlNotesEngine from '../UmlWorkspace/Core/UmlNotesEngine';
import umlPkgLibEngine from '../UmlWorkspace/UmlPkgLib/Core/UmlPkgLibEngine';
import fearGreedEngine from '@/Widgets/DataPainterWidget/CmcFearWidget/CmcFearEngine';
import rsiEngine from '@/Widgets/DataPainterWidget/RsiWidget/RsiEngine';
import boardEngine from '@/Widgets/DataPainterWidget/BoardWidget/BoardEngine';

export const createSRHandlers = () => ({
    // OnCardDataUpdated: {
    //     handle: (envelope) => {
    //         cardDataListener.onMessage(envelope);
    //     },
    // },

    OnCalendarEventCreated: {
        handle: (data) => {
            calendarEngine.onCalEventUpdated(data);
        },
    },

    OnCmcFearUpdated: {
        handle: (data) => {
            fearGreedEngine.onFearIndexReceived(data);
        },
    },

    OnRsiSlotsV1Updated: {
        handle: (data) => {
            rsiEngine.onRsiReceived(data);
        },
    },

    // ADDED — fetch user after SignalR auth complete
    OnUserStateV2Restored: {
        handle: async () => {
            const result = await userEngine.onRestored();
            if (result !== true) {
                // TODO: publish error for UI — result is error code or false
            }
        },
    },

    // for YourDataTab
    OnJournalCreated: {
        handle: (entries) => {
            // yourNoteEngine.onJournalUpdated(data);
            searchEngine.onJournalUpdated(entries);
            yourDataEngine.onJournalUpdated(entries);
            templateEngine.onJournalUpdated(entries);

            formConfigEngine.onJournalUpdated(entries);
            umlNotesEngine.onJournalUpdated(entries);
            umlPkgLibEngine.onJournalUpdated(entries);

            boardEngine.onJournalUpdated(entries);
        },
    },

    OnJournalUpdated: {
        // update entries
        handle: (entries) => {
            // yourNoteEngine.onJournalUpdated(data);

            noteOptionsPanelEngine.OnJournalUpdated(entries);
            bodyEditorEngine.onJournalUpdated(entries);

            searchEngine.onJournalUpdated(entries);
            yourDataEngine.onJournalUpdated(entries);
            templateEngine.onJournalUpdated(entries);

            formConfigEngine.onJournalUpdated(entries);
            csCodeTemplateEngine.onJournalUpdated(entries);
            csCodeGenConfigEngine.onJournalUpdated(entries);
            umlNotesEngine.onJournalUpdated(entries);
            umlPkgLibEngine.onJournalUpdated(entries);

            boardEngine.onJournalUpdated(entries);
        },
    },
    OnJournalDeleted: {
        handle: (entries) => {
            entries.forEach((item) => {
                groupNodeEngine.onNoteDeleted(item.rk);
                searchEngine.onNoteDeleted(item.rk);
                yourDataEngine.onNoteDeleted(item.rk); // ADDED

                formConfigEngine.onJournalDeleted(item.rk);

                csCodeTemplateEngine.onJournalDeleted(item.rk);
                csCodeGenConfigEngine.onJournalDeleted(item.rk);
                umlNotesEngine.onJournalDeleted(item.rk);
                umlPkgLibEngine.onJournalDeleted(item.rk);
            });
        },
    },

    // yourNotesTab
    OnEntriesAdded: {
        handle: (data) => {
            groupNodeEngine.onEntriesAdded(data);
        },
    },

    OnEntryNodesResolved: {
        handle: (cmd) => {
            groupNodeEngine.onEntryNodesResolved(cmd);
            searchEngine.onJournalUpdated([cmd.entry]);
            yourDataEngine.onJournalUpdated([cmd.entry]);
            templateEngine.onJournalUpdated([cmd.entry]);

            floatingPanelEngine.OnEntryNodesResolved(cmd);

            formConfigEngine.onJournalUpdated([cmd.entry]);

            csCodeTemplateEngine.onJournalUpdated([cmd.entry]);
            csCodeGenConfigEngine.onJournalUpdated([cmd.entry]);
            umlNotesEngine.onJournalUpdated([cmd.entry]);
            umlPkgLibEngine.onJournalUpdated([cmd.entry]);
        },
    },

    OnTopicGroupsRecreated: {
        handle: (data) => {
            topicGroupEngine.onGroupsRecreated(data);
        },
    },
    OnTopicGroupChanged: { handle: (data) => topicGroupEngine.onGroupChanged(data) },
    OnTopicGroupCreated: { handle: (data) => topicGroupEngine.onGroupCreated(data) },

    OnTopicGroupMetaUpdated: { handle: (data) => topicGroupEngine.onGroupsMetaDataUpdated(data) },

    OnGroupNodesLoaded: {
        handle: (data) => {
            groupNodeEngine.onGroupNodesLoaded(data);
            // also notify TopicGroupEngine for activeNodeId/activeEntryId restore
            topicGroupEngine.onGroupNodesLoaded(data);
        },
    },
});
